.widgetEditorAbsolute {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--vkui--color_background_content);
}
